//英语
export default
{ 
 common: { 
       notshow: 'Don\'t show today',
 unit: 'USDT', 
 day: 'Day', 
 week: 'Week', 
 save: 'Save', 
 submit: 'Submit', 
 confirmtitle: 'Confirm to execute operation', 
 confirm: 'Confirm', 
 reset: 'Reset', 
 refresh: 'Refresh', 
 copy: 'Copy', 
 copysuccessful: 'Copy successful', 
 modify: 'Modify', 
 binding: 'Binding', 
 finished: 'Completed', 
 canceled: 'Canceled', 
 cancel: 'Cancel', 
 all: 'All', 
 back: 'Back', 
 loading: 'Loading...', 
 nomore: 'All records', 
 errortxt: 'Failed to load', 
 loosing: 'Release to refresh...', 
 pulling: 'Pull down to refresh...', 
 nodata: 'No records for now', 
 buy: 'Buy', 
 buyup: 'Buy Long', 
 buydown: 'Sell Short', 
 sell: 'Sell', 
 forserver: 'Customer service', 
 total: 'Total', 
 status1: 'Pending review', 
 status2: 'Completed', 
 status3: 'Not passed', 
 paytype1:'TRC20', 
 paytype2: 'ERC20', 
 paytype3: 'Wire transfer', 
 }, 
 footer: { 
 home: 'Home', 
 market: 'Market', 
 exchange: 'Trade', 
 options: 'Options', 
 assets:'Assets', 
 change: 'Transfer', 
 recharge: 'Deposit', 
 withdrawal: 'Withdrawal' 
 }, 
 home: { 
 menu1:'Options trading', 
 menu1desc: 'Supports BTC/USDT, etc.', 
 menu2: 'Recharge', 
 menu3: 'Withdraw', 
 menu4: 'Customer service', 
 menu5: 'Flash swap', 
 menu6: 'Boost loan', 
 menu7: 'Stake mining', 
 menu8: 'Staking', 
 menu9: 'Transfer', 
 ranktitle: 'Increase ranking', 
 name: 'Name', 
 price: 'Latest price', 
 risefall: 'Chg%', 
 }, 
 register: { 
 register: 'register', 
 login: 'login', 
 email: 'Email', 
 phone: 'Phone number', 
 accountplaceholder: 'Please enter your account', 
 emailplaceholder: 'Please enter your email', 
 phoneplaceholder: 'Please enter your phone number', 
 pwdplaceholder:'Please enter your password', 
 pwdplaceholder1:'Password should be 6-20 letters and numbers', 
 agepwdplaceholder: 'Please re-enter your password', 
 agepwdplaceholder1: 'Passwords do not match', 
 invitecodeplaceholder: 'Please enter the invitation code', 
 remember: 'Remember password', 
 fotget: 'Forgot password' 
 }, 
 market:{ 
 title: 'Market', 
 all: 'All' 
 }, 
 member:{ 
 reputation:'Reputation score', 
 identity_authentication:'Authentication', 
 under_review:'Under review', 
 certified:'Certified', 
 awaiting_certification:'Awaiting certification', 
 binding_withdrawal_address: 'Bind withdrawal address', 
 currently_selected_currency:'Currently selected currency', 
 withdrawal_address:'Withdrawal address', 
 sharing_link:'My sharing link', 
 my_promotion_code:'My promotion code', 
 promotion_code:'Promotion code', 
 system_message:'System message', 
 night_mode:'Night mode', 
 security_center:'Security', 
 seted: 'Set', 
 noset: 'Not set', 
 login_password:'Login password', 
 transaction_password:'Withdrawal password', 
 app_download:'App download', 
 log_out:'Log out' ,
        aboutus: 'Website Introduction'
 }, 
 identity:{ 
 title: 'Identity verification', 
 name: 'Name', 
 nameplaceholder: 'Please enter your real name', 
 uploader: 'Upload ID photo', 
 tip1: 'Upload front side of ID', 
 tip2: 'Upload back side of ID' 
 }, 
 address: { 
 title: 'Bind withdrawal address', 
 bType: 'Currently selected currency', 
 address: 'Withdrawal address', 
 addressplaceholder:'Please enter your withdrawal address', 
 }, 
 security:{ 
 title: 'Security center', 
 modifypwd: 'Login password', 
 resetlegalpwd: 'Transaction password', 
 loginpwd: 'New login password', 
 pwdage: 'Confirm password', 
 loginpwdplaceholder:'Please enter your current login password', 
 loginnewpwdplaceholder: 'Please enter your new login password', 
 moneypwd: 'Please enter your transaction password', 
 pwdageplaceholder:'Please re-enter your password' 
 }, 
 trade:{ 
 title: 'Spot trading', 
 price: 'Price', 
 num: 'Quantity', 
 entrust: 'Current entrust', 
 clinch: 'Actual trade', 
 used: 'Available', 
 buyed: 'Available to buy', 
 amount: 'Trade amount', 
 limitprice: 'Limit price', 
 marketprice: 'Market price', 
 forprice: 'Trade at the current best price', 
 errorMoney: 'Insufficient available balance', 
 priceerror: 'Please enter the entrust price', 
 numerror: 'Please enter the entrust quantity', 
 moneyerror: 'Please enter the entrust amount', 
 }, 
 assets:{ 
 allconvert:'Total assets converted', 
 usenum: 'Available', 
 freeze: 'Frozen', 
 convert: 'Converted', 
 tab1:'Assets', 
 tab11: 'Total assets converted', 
 tab12: 'Options converted', 
 tab13: 'Funds converted', 
 tab14: 'Quant trading converted', 
 tab2:'Options', 
 tab21: 'Options account', 
 tab3:'Funds', 
 tab31:'Funds account', 
 tab4:'Quant trading', 
 tab41:'Quant trading account', 
 tbhead1: 'Financial records', 
 tbhead2: 'Withdrawal records', 
 tbhead3: 'Deposit records', 
 tbhead4: 'Transfer records', 
 rcdnum: 'Quantity', 
 rcd: 'Record', 
 rcdtime: 'Time' , 
 rcdstatus: 'Status', 
 rcddesc: 'Description', 
 rcdaddress: 'Deposit address' 
 }, 
 change:{ 
 title: 'Transfer', 
 from: 'From {name}', 
 to: 'To {name}', 
 frmtitle: 'Transfer quantity', 
 inputplaceholder: 'Please enter the transfer quantity', 
 btntxt:'Transfer' 
 }, 
 recharge:{ 
 title: 'Deposit', 
 bType: 'Current currency', 
 address: 'Deposit address', 
 token: 'Payment voucher', 
 tokenplaceholder: 'Please upload the payment voucher', 
 num: 'Deposit', 
 numplaceholder: 'Please enter the quantity', 
 btn: 'Submit for review', 
 bankname: 'Bank name', 
 bankno: 'Card number', 
 accountname: 'Recipient name', 
 bankaddress: 'Bank address', 
 bankcode: 'Bank transfer code', 
 companyaddress: 'Company address' 
 }, 
 withdrawal:{ 
 title:'Withdrawal', 
 frmtitle1: 'Quantity', 
 frmplaceholder1: 'Withdrawal quantity should be between {min} - {max}', 
 frmtitle2: 'Transaction password', 
 frmplaceholder2: 'Please enter your transaction password', 
 getnum: 'Received quantity', 
 fee:'Fee', 
 btn: 'Withdraw' 
 }, 
 exchangeb:{ 
 title: 'Exchange', 
 account: 'Account', 
 btn: 'Exchange', 
 numerror: 'Please enter the exchange quantity' 
 }, 
 option:{ 
 title: 'Options', 
 typetitle: 'Second contract', 
 listtitle: 'Positions', 
 kline: 'K-line', 
 high: 'High', 
 low: 'Low', 
 nums: '24H volume', 
 time: 'Time', 
 transaction: 'Transaction mode', 
 quantity: 'Opening quantity', 
 quantityerror: 'Please enter the opening quantity', 
 times: 'Opening time', 
 times1: 'Settlement Time',
 account: 'Account balance', 
 buyup:'BUY LONG', 
 buydown: 'SELL SHORT', 
 tab1: 'Position list', 
 tab2: 'Order records', 
 num: 'Quantity', 
 price1: 'Purchase price', 
 price2: 'Filled price', 
 profitandloss: 'Estimated profit/loss', 
 profitandloss1: 'Profit/Loss', 
 countdown: 'Countdown', 
 waitfinish: 'Pending settlement',
 finishing: 'Settling...',
 finished: 'Settled',
 order_price: 'Current price',
 order_cycle: 'Cycle',
 order_type: 'Type',
 order_money: 'Amount',
 order_time: 'Position establishment',
 order_get: 'Profit',
 order_btn: 'Place another order'
},
tradelst: {
 title: 'My Orders',
 tab1: 'Orders',
 tab2: 'Completed Trades',
 tab3: 'Cancelled',
 usdtnum: ''
},
loans: {
       repayment: 'Repayment',
 title: 'Boost Loan',
 order_tab: 'Loan Orders',
 pro_tab: 'Loan Products',
 Institution: 'Lending Institution',
 Amount: 'Amount',
 DailyInterest: 'Daily Interest Rate',
 RepaymentPeriod: 'Repayment Period',
 Application: 'Apply for Loan',
 orderno: 'Order No.',
 AllInterest: 'Total Interest',
 RepaymentDate: 'Repayment Date',
 RepaymentMethod: 'Repayment Method',
 Onetime: 'One-time',
 Expected_loan_amount: 'Expected Loan Amount',
 Expected_loan_amounterror: 'Loan amount should be between {min} - {max}',
 imgplaceholdr: 'Credit lending (ensure images are clear)',
 icon1: 'Upload ID front',
 icon2: 'Upload ID back',
 icon3: 'Upload ID with holder',
 status1: 'Pending',
 status2: 'Approved',
 status3: 'Rejected',
},
lockming: {
 title: 'Stake Mining',
 order_tab: 'Mining Rig Orders',
 pro_tab: 'Mining Rig Market',
 locknum: 'Minimum Stake Amount',
 getforday: 'Yield Rate/Day',
 days: 'Days',
 estimation: 'Estimated Yield',
 real: 'Actual Yield',
 balance: 'Wallet Balance',
 nums: 'Stake Amount',
 tolockming: 'Stake',
 stime: 'Start Time',
 etime: 'End Time',
},
transfer: {
 title: 'Account Transfer',
 searchtxt: 'Please enter the recipient account',
 ReceivingAccount: 'Recipient Account Information',
 toaccount: 'Account',
 confirmtxt: 'Please confirm the recipient account',
 confirmedtxt: 'Recipient account confirmed',
 numtxt: 'Transfer Quantity',
 numerror: 'Please enter the transfer quantity',
 fee: 'Internal transfers are free',
 ArrivalTime: 'Arrival Time',
 Immediately: 'Immediate arrival',
 realnum: 'Actual Arrival Quantity',
 btn: 'Confirm Transfer',
 transfering: 'Transferring...',
 orderNo: 'Order No.',
 stime: 'Transfer Time',
 etime: 'Arrival Time',
 receiving: 'Recipient Account',
 type: 'Currency',
 num: 'Transfer Quantity',
 arrivalnum: 'Credit Quantity'
},
staking: {
 title: 'Staking',
 record: 'Records',
 getforyear: 'Estimated Annual Yield',
 time: 'Investment Period',
 snum: 'Minimum Investment Amount',
 snumerror: 'Please enter the investment amount',
 snumerror1: 'Investment amount should not be less than {num}',
 join: 'Participate Now',
 opentime: 'Investment Time',
 money: 'Invested Amount',
 days: 'Period',
 recordget: 'Annual Yield',
 gets: 'Yield',
 stime: 'Start Date',
 etiem: 'End Date',
 redeemStaking: 'Redeem',
 status0: 'Staking',
 status1: 'Order Ended',
 status2: 'Order Redeemed',
},
bank:{
       title: 'Link Bank Card',
       bankName: 'Bank Name',
       bankNameError: 'Bank name required',
       usrName: 'Cardholder Name',
       usrNameError: 'Cardholder name required',
       cardCode: 'Card Number',
       cardCodeError: 'Card number required',
       towallet: 'Withdraw to Digital Wallet',  // Cryptocurrency compliant
       tobank: 'Withdraw to Bank Account',    // Updated per FATF Recommendation 15
       sendcode: 'Send Verification Code',
       sended: 'Resend in {num}s',            // ISO 8601 time format standard
       verify_code: 'Email Verification Code'
     }
     
}
